export const producersSortArray = ['amatic', 'evolution', 'pragmaticplaylive', 'pragmaticplay', 'Sport']
export const excludeProducersArray = ['bcraft', 'evolution', 'pragmaticexternal', 'pragmatic']

export const intergrationsExcludeArray = ['89fa86ca']

export const renameProducerForBetshistory: Record<string, string> = {
  evosw: 'evolution',
}

export const changeProviderBeforeSend = (provider: string) => {
  switch (provider) {
    case 'all':
      return undefined
    default:
      return provider
  }
}
